app.directive('questionInput',
  ['$location', '$timeout', 'dataConvert', 'rankingHelper', 'portalHelper', 'multiselects',
    'CONSTANTS', 'stringHelper', '$rootScope', 'apiHelper', 'HttpAuth', 'authHelper',
    function ($location, $timeout, dataConvert, rankingHelper, portalHelper, multiselects,
      CONSTANTS, stringHelper, $rootScope, apiHelper, HttpAuth, authHelper) {
      return {
        scope: {
          question: '=',
          response: '=',
          disabled: '@',
          responses: '=',
          responsesNew: '=',
          emptyForm: '@',
          questionPreview: '@',
          currencies: '=',
          isClientRatingScale: '@',
          idPrefix: '@',
          screenName: '=',
          showValidationInComponent: '<',
          isResponseValid: '='
        },
        templateUrl: portalHelper.getUrlRev('html_templates/directives/question_input.b29fc6e4.html'),
        controller: function ($scope) {
          $scope.model_dropdown = '';
          $scope.isMultiRationale = portalHelper.isMultiRationale;
          $scope.isNullOrEmpty = stringHelper.isNullOrEmpty;
          $scope.otherOptionsEnum = CONSTANTS.otherOptions;
          $scope.isSingleRationale = portalHelper.isSingleRationale;
          $scope.responseValidation = {
            isValid: null
          };

          const getRandomizedOptions = function () {
            $timeout(
              function () {
                $scope.randomizedOptions = portalHelper.getRandomizedOptions(
                  $scope.question,
                  $scope.response,
                  $scope.seedToRandomizeOptions
                );
              }
            );
          };

          $scope.enableValidationMessages = stringHelper.isNullOrEmpty($scope.$parent['enableValidationMessages'])
            ? false
            : $scope.$parent.enableValidationMessages;
          $scope.CONSTANTS = CONSTANTS;
          $scope.isInMultiPageSurvey = $scope.$parent.survey == undefined ? null : $scope.$parent.survey.multi_page;
          $scope.has_long_dropdown_options = portalHelper.tor_classic_has_long_dropdown_options;

          this.$onInit = function () {
            if ($scope.question.randomize_options && $scope.response.randomization_seed) {
              // During survey authoring, we don't have response yet, so we pass seed
              // to show randomization. In all other cases, response will have a seed.
              $scope.seedToRandomizeOptions = $scope.response.randomization_seed;
            }
            else if (portalHelper.is_test_survey()){
              const cryptoObj = (globalThis.crypto || globalThis.msCrypto);
              if (cryptoObj?.getRandomValues) {
                const randomBuffer = new Uint32Array(1);
                cryptoObj.getRandomValues(randomBuffer);
                $scope.seedToRandomizeOptions = Math.floor(randomBuffer[0] * $scope.question.id);
              } else {
                $scope.seedToRandomizeOptions = Date.now() * ($scope.question.id || 1);
              }
            }

            // This function deals with randomization of options for all question types
            // on payer view screen, responses screen and clarification screens.
            getRandomizedOptions();
            if ($scope.emptyForm) {
              $scope.$watch('question.scale', function (oldValue, newValue){
                getRandomizedOptions();
              }, true);
            }

          };

          const variableToWatch = function () {
            return JSON.stringify($scope.responseValidation);
          };

          // Initialize the watchers which produce API friendly data structure on changes
          $scope.$watch(variableToWatch, function () {
            $scope.isResponseValid = $scope.responseValidation.isValid;
          }, true);

          $scope.getCurrencyName = function (currencyId) {
            if (!currencyId) {
              return '';
            }

            if (typeof (currencyId) == 'string') {
              return currencyId;
            }

            if ($scope.currencies) {
              return $scope.currencies.find(function (elem) {
                return elem.id == currencyId;
              }).code;
            }
          };

          $scope.validateVWInputs = function () {
            $timeout(
              function () {
                const acceptableQuestionInput = $('#question-' + $scope.question.id + '-response #acceptable_question_input');
                const expensiveQuestionInput = $('#question-' + $scope.question.id + '-response #expensive_question_input');
                const tooExpensiveQuestionInput = $('#question-' + $scope.question.id + '-response #too_expensive_question_input');
                const prohibitiveQuestionInput = $('#question-' + $scope.question.id + '-response #prohibitive_question_input');

                const acceptable_value = parseFloat(acceptableQuestionInput.val());
                const expensive_value = parseFloat(expensiveQuestionInput.val());
                const too_expensive_value = parseFloat(tooExpensiveQuestionInput.val());
                const prohibitive_value = parseFloat(prohibitiveQuestionInput.val());

                if (acceptable_value >= expensive_value) {
                  acceptableQuestionInput.addClass('input-error');
                  $scope.question.errors['acceptable_question_input'] =
                    'This value should be smaller than the next price point';
                } else if (acceptable_value > 0 && acceptable_value < 100000000) {
                  acceptableQuestionInput.removeClass('input-error');
                  $scope.question.errors['acceptable_question_input'] = '';
                }

                if (expensive_value >= too_expensive_value || expensive_value < acceptable_value) {
                  expensiveQuestionInput.addClass('input-error');
                  $scope.question.errors['expensive_question_input'] =
                    'This value should be greater than the previous price point\
                                and smaller than the next price point';
                } else if (expensive_value > 0 && expensive_value < 100000000) {
                  expensiveQuestionInput.removeClass('input-error');
                  $scope.question.errors['expensive_question_input'] = '';
                }

                if (too_expensive_value >= prohibitive_value || too_expensive_value < expensive_value) {
                  tooExpensiveQuestionInput.addClass('input-error');
                  $scope.question.errors['too_expensive_question_input'] =
                    'This value should be greater than previous price point\
                                and smaller than the next price point';
                } else if (too_expensive_value > 0 && too_expensive_value < 100000000) {
                  tooExpensiveQuestionInput.removeClass('input-error');
                  $scope.question.errors['too_expensive_question_input'] = '';
                }

                if (prohibitive_value < too_expensive_value) {
                  prohibitiveQuestionInput.addClass('input-error');
                  $scope.question.errors['prohibitive_question_input'] =
                    'This value should be greater than previous price point';
                } else if (prohibitive_value > 0 && prohibitive_value < 100000000) {
                  prohibitiveQuestionInput.removeClass('input-error');
                  $scope.question.errors['prohibitive_question_input'] = '';
                }
              }
              , 2000);
          };

          multiselects.initTableOfResponses($scope);

          if (!angular.isDefined($scope.response) || !$scope.response) {
            //not sure why it's not automatically created within directive... worked fine outside of directive
            $scope.response = {};
            $scope.response.rating_responses = {};
            $scope.response.ranking_responses = {};
            $scope.response.points_allocation_responses = {};
            $scope.response.other_options = [];

            $scope.response.allow_payer_option = $scope.question.allow_payer_option;

            if ($scope.question.type_name === 'ranking_scale') {
              //initialize fake ranking responses to draw drag & drop
              rankingHelper.initFakeRankingResponsesSaved($scope.response, $scope.question);
              rankingHelper.initFakeRankingResponsesNotSaved($scope.response, $scope.question);
            }
          }

          // Checks if the response has a payer_option_selected field defined
          if ($scope.response['payer_option_selected'] == undefined || $scope.response['payer_option_selected'] == null) {
            $scope.response.payer_option_selected = !stringHelper.isNullOrEmpty($scope.response.payer_option);
          }

          $scope.getSumPoints = function () {
            let sum = 0;
            for (const option_name in $scope.response.points_allocation_responses) {
              if (!stringHelper.isNullOrEmpty($scope.response.points_allocation_responses[option_name].points)) {
                sum += parseInt($scope.response.points_allocation_responses[option_name].points);
              }
            }

            if (!stringHelper.isNullOrEmpty($scope.response.payer_option) &&
            !stringHelper.isNullOrEmpty($scope.response.payer_points)) {
              sum += parseInt($scope.response.payer_points);
            }

            return sum;
          };

          $scope.getRatingResponseCount = function () {
            let count = 0;

            for (const option_name in $scope.response.rating_responses) {
              if (!stringHelper.isNullOrEmpty($scope.response.rating_responses[option_name]) &&
                !stringHelper.isNullOrEmpty($scope.response.rating_responses[option_name].value)) {

                count += 1;
              }
            }

            if (!stringHelper.isNullOrEmpty($scope.response.payer_value)) {
              count += 1;
            }

            return count;
          };

          $scope.getSliderRatingResponseCount = function () {
            let count = 0;

            for (const option_name in $scope.response.rating_responses) {
              const option = $scope.response.rating_responses[option_name];
              if (!stringHelper.isNullOrEmpty(option) &&
                (!stringHelper.isNullOrEmpty(option.value || !stringHelper.isNullOrEmpty(option.non_discrete_scale_value)))
              ) {

                count += 1;
              }
            }

            if (!stringHelper.isNullOrEmpty($scope.response.payer_value) || !stringHelper.isNullOrEmpty($scope.response.non_discrete_payer_value)) {
              count += 1;
            }

            return count;
          };

          $scope.getRatingResponseQuestionsCount = function () {
            let count = 0;
            let question_count = $scope.question.options.length;

            for (const option_name in $scope.response.rating_responses) {
              count += 1;
            }

            if (!stringHelper.isNullOrEmpty($scope.response.payer_option)) {
              count += 1;
              question_count += 1;
            }

            // When no response has been recorded, question length gives the correct answer
            // However, for multiple and single 'other' options, the response.rating_responses
            // gives a better answer
            return Math.max(count, question_count);
          };

          // Sum of only user-defined column widths (excluding auto first column)
          const getDefinedColumnsTotal = function () {
            if (!$scope.question?.scale) {
              return 0;
            }
            let total = 0;
            const values = $scope.question.scale.values || [];
            for (const value of values) {
              total += (Number.parseFloat(value.percentage_width) || 0);
            }
            const rawWidths = $scope.question.scale.more_info_column_widths;
            const moreInfoWidths = Array.isArray(rawWidths) ? rawWidths : Object.values(rawWidths || {});
            const moreInfoCount = $scope.question.scale.numberOfMoreInfoColumns || $scope.question.scale.more_info_columns_count || 0;
            for (let j = 0; j < Math.min(moreInfoWidths.length, moreInfoCount); j++) {
              total += (Number.parseFloat(moreInfoWidths[j]) || 0);
            }
            return total;
          };

          // Total table width as % of screen (defined columns + first column)
          const getCustomWidthTotal = function () {
            const defined = getDefinedColumnsTotal();
            // First column: fills remaining up to 100%, minimum 20% of screen
            const firstCol = Math.max(20, 100 - defined);
            return defined + firstCol;
          };

          // Gets the actual rendered table width (rounded to nearest 10 for CSS class)
          function getRenderedTableWidth() {
            const total = getCustomWidthTotal();
            if (total > 100) {
              return Math.min(450, Math.ceil(total / 10) * 10);
            }
            return 100;
          }

          // Returns first column width as % of TABLE so it renders as the correct % of SCREEN
          function getFirstColumnWidth() {
            const defined = getDefinedColumnsTotal();
            if (defined === 0) {
              return 50;
            }
            // Desired screen width for first column
            const screenWidth = Math.max(20, 100 - defined);
            const renderedWidth = getRenderedTableWidth();
            if (renderedWidth > 100) {
              // Convert screen % to table %
              return screenWidth / renderedWidth * 100;
            }
            return screenWidth;
          }

          $scope.calculateRankingFirstColumnAutoWidth = function() {
            if ($scope.question && $scope.question.scale && $scope.question.scale.values) {
              return getFirstColumnWidth();
            }
          };

          $scope.calculateRatingFirstColumnAutoWidth = function() {
            if ($scope.question && $scope.question.scale && $scope.question.scale.values) {
              return getFirstColumnWidth();
            }
          };

          const getColumnsWeight = function () {
            if (!$scope.question?.scale) {
              return false;
            }
            const scaleValuesLength = $scope.question.scale.values ? $scope.question.scale.values.length : 0;
            const numberOfMoreInfoColumns = $scope.question.scale.numberOfMoreInfoColumns || 0;
            // Each more info column takes up 2 columns
            return 2 + scaleValuesLength + numberOfMoreInfoColumns * 2;
          };

          const isScaleOptionsRequiresWideLayout = function () {
            return $scope.isMultiRationale($scope.question.rationale_type) && getColumnsWeight() > 15;
          };

          // Convert a screen-% width to a table-% width when table is wider than 100%
          $scope.screenToTableWidth = function (screenPercent) {
            const renderedWidth = getRenderedTableWidth();
            if (renderedWidth > 100) {
              return screenPercent / renderedWidth * 100;
            }
            return screenPercent;
          };

          $scope.getOverFlowClass = function () {
            if (getCustomWidthTotal() > 100) {
              return 'overflow-x-auto';
            }
            return isScaleOptionsRequiresWideLayout() ? 'overflow-x-auto' : '';
          };

          $scope.getScaleTableClass = function () {
            const customTotal = getCustomWidthTotal();
            if (customTotal > 100) {
              return 'sticky-first-column';
            }
            return isScaleOptionsRequiresWideLayout() ? ('sticky-first-column w-' + $scope.calculateRatingTableWidth()) : 'table-responsive';
          };

          // Returns inline style for the table width in vw units when custom widths are defined.
          // Using vw ensures column widths are relative to the viewport/screen, not the parent container.
          $scope.getTableWidthStyle = function () {
            const customTotal = getCustomWidthTotal();
            if (customTotal > 100) {
              return {'width': getRenderedTableWidth() + 'vw'};
            }
            return {};
          };

          $scope.calculateRatingTableWidth = function () {
            if (isScaleOptionsRequiresWideLayout()) {
              const extraColumns = getColumnsWeight() - 15;
              // Base width is 100%, each extra column adds 20% to the width
              // This is to ensure that the table does not become too cramped when there are many scale options
              // and more info columns and this usually happens on smaller screens or on mac screens where device pixel ratio is 2
              // e.g. 3024px width screen will be treated as 1512px width screen
              return 100 + (extraColumns * 10);
            }
            return 100;
          };
          $scope.requiredRankingValuesCount = function () {
            let requiredOptionValuesCount = $scope.question.scale.values.length;
            const optionsCount = $scope.question.scale.options.length;
            if ($scope.question.allow_payer_option && optionsCount < requiredOptionValuesCount && !$scope.response.payer_option) {
              requiredOptionValuesCount -= 1;
            }
            return requiredOptionValuesCount;
          };

          $scope.getRankingResponseCount = function () {
            let count = 0;
            for (const option_name in $scope.response.ranking_responses) {
              if (!stringHelper.isNullOrEmpty($scope.response.ranking_responses[option_name]) &&
                !stringHelper.isNullOrEmpty($scope.response.ranking_responses[option_name].value)) {

                count += 1;
              }
            }

            // while taking a pilot survey as admin, since response are not fetched from backend
            // $scopre.response.allow_payer option is undefined
            // $scope.question.allow_payer_option is available both in payer and admin portal
            if ($scope.question.allow_payer_option == CONSTANTS.otherOptions.SINGLE_OTHER &&
                !stringHelper.isNullOrEmpty($scope.response.payer_option) &&
                !stringHelper.isNullOrEmpty($scope.response.payer_value)) {
              count += 1;
            }
            return count;
          };

          $scope.getItemsToRankCount = function () {
            if ($scope.question.scale == null || !$scope.question.scale.options) {
              return 0;
            }
            if ($scope.question.scale.items_to_rank == null) {
              return $scope.question.scale.options.length;
            }

            return $scope.question.scale.items_to_rank;
          };

          $scope.getTableResponsesCount = function () {
            let count = 0;

            for (const option_name in $scope.response.table_responses) {
              if (!stringHelper.isNullOrEmpty($scope.response.table_responses[option_name])) {
                let ansCount = 0;

                for (const col_name in $scope.response.table_responses[option_name]) {
                  if (!stringHelper.isNullOrEmpty($scope.response.table_responses[option_name][col_name]) &&
                    (!stringHelper.isNullOrEmpty($scope.response.table_responses[option_name][col_name].answer) ||
                      !stringHelper.isNullOrEmpty($scope.response.table_responses[option_name][col_name].option))) {
                    ansCount += 1;
                  }
                }

                if (ansCount > 0) {
                  count += 1;
                }
              }
            }

            return count;
          };

          $scope.getTableQuestionsCount = function (question) {
            if (question.scale.options) {
              return question.scale.options.length;
            }

            return 0;
          };

          $scope.payer_option_change = function () {
            // Clear payer points if option is empty
            if (stringHelper.isNullOrEmpty($scope.response.payer_option)) {
              $scope.response.payer_points = null;
              $scope.response.payer_rationale = '';
            }
          };

          $scope.payer_point_change = function () {
            // Clean payer rationale if payer point is empty.
            if (stringHelper.isNullOrEmpty($scope.response.payer_points)) {
              $scope.response.payer_rationale = '';
            }
          };

          $scope.add_multi_other_option = function () {
            if (!$scope.response.other_options) {
              $scope.response.allow_payer_option = CONSTANTS.otherOptions.MULTIPLE_OTHER;
              $scope.response.other_options = [{
                'option_name': ''
              }];
            } else {
              $scope.response.other_options.push({ 'option_name': '' });
            }
          };


          $scope.clearUiSelect = function ($event, $select) {
            $event.stopPropagation();
            $select.clear($event);
          };

          $scope.delete_multi_other_option = function (other_index, option) {
            if ($scope.disabled == 'true') {
              return;
            }

            portalHelper.showPopupYesNo(
              '',
              'Are you sure you want to delete this option?',
              function () {
                if (option.option_name in $scope.response.rating_responses) {
                  delete $scope.response.rating_responses[option.option_name];
                }

                $scope.response.other_options.splice(other_index, 1);
                $scope.$apply(); // call from popup
              }
            );
          };

          $scope.multi_other_option_change = function (cur_option, old_option) {
            if ($scope.response.rating_responses[old_option]) {
              if (cur_option) {
                $scope.response.rating_responses[cur_option] = angular.copy($scope.response.rating_responses[old_option]);
              }
              delete $scope.response.rating_responses[old_option];
            } else if (cur_option && !$scope.response.rating_responses[cur_option]) {
              // add empty response (so that option will be saved on autosave
              $scope.response.rating_responses[cur_option] = { 'value': null };
            }
          };

          $scope.updateCheckboxResponses = function (option) {
            //remove checkbox response from the list if it's unchecked (we don't need to post to api)
            if (!$scope.response.checkbox_responses[option.id].checked) {
              delete $scope.response.checkbox_responses[option.id];
            }
          };

          function updateRankingScaleValues() {
            // here we need to update scale values (when ranking order changes)
            const all_values = $scope.question.scale.values;

            if (!angular.isDefined($scope.response)) {
              $scope.response = {};
            }

            for (let k = 0; k < $scope.response.ranking_responses_saved.length; k++) {
              if (k < all_values.length) {
                $scope.response.ranking_responses_saved[k].value = all_values[k].id;
              }
            }

            for (let k = 0; k < $scope.response.ranking_responses_not_saved.length; k++) {
              $scope.response.ranking_responses_not_saved[k].value = null;
            }

            $scope.response.ranking_responses = angular.copy(
              dataConvert.convert_to_dict($scope.response.ranking_responses_saved, 'option'));
          }

          function highlight_drag_drop_destination(id, status) {
            const srcContainer = $('#ranking-scale-question-' + id).find('.src-list')[0];
            const dstContainer = $('#ranking-scale-question-' + id).find('.dst-list')[0];

            const srcPlaceholder = $(srcContainer).find('.src-placeholder')[0];
            const dstPlaceholder = $(dstContainer).find('.dst-placeholder')[0];

            // Fix the height of both the boxes to be equal to make it easier to drag / drop items
            const srcHeight = $(srcPlaceholder).height();
            const dstHeight = $(dstPlaceholder).height();

            const maxHeight = Math.max(srcHeight, dstHeight);

            $(srcPlaceholder).css('min-height', maxHeight + 'px');
            $(dstPlaceholder).css('min-height', maxHeight + 'px');

            // Changing the class of the containers
            $(srcPlaceholder).removeClass('active');
            $(dstPlaceholder).removeClass('active');

            if (status == true) {
              $(srcPlaceholder).addClass('active');
              $(dstPlaceholder).addClass('active');
            }
          }

          $scope.drag_not_saved = {
            accept: function (sourceItemHandleScope, destSortableScope) {
              const srcQuestionId = $(sourceItemHandleScope.itemScope.element)
                .attr('data-question-id');
              const dstQuestionId = $(destSortableScope.element).attr('data-question-id');

              return srcQuestionId == dstQuestionId;
            },
            itemMoved: function (event) {
              updateRankingScaleValues();
            },
            orderChanged: function (event) {
              updateRankingScaleValues();
            },
            dragStart: function (event) {
              const questionId = $(event.source.itemScope.element).attr('data-question-id');
              highlight_drag_drop_destination(questionId, true);
            },
            dragEnd: function (event) {
              const questionId = $(event.source.itemScope.element).attr('data-question-id');
              highlight_drag_drop_destination(questionId, false);
            }
          };

          $scope.drag_saved = {
            accept: function (sourceItemHandleScope, destSortableScope) {
              const srcQuestionId = $(sourceItemHandleScope.itemScope.element)
                .attr('data-question-id');
              const dstQuestionId = $(destSortableScope.element).attr('data-question-id');
              return srcQuestionId == dstQuestionId;
            },
            itemMoved: function (event) {
              updateRankingScaleValues();
            },
            orderChanged: function (event) {
              updateRankingScaleValues();
            },
            dragStart: function (event) {
              const questionId = $(event.source.itemScope.element).attr('data-question-id');
              highlight_drag_drop_destination(questionId, true);
            },
            dragEnd: function (event) {
              const questionId = $(event.source.itemScope.element).attr('data-question-id');
              highlight_drag_drop_destination(questionId, false);
            }
          };

          function updateTextAreaHeights(elem) {
            const table = $(elem).closest('table');
            autosize.update($(table).find('textarea.expandable'));
          }

          // expandable heights for table of responses
          $timeout(function () {
            autosize($('textarea.expandable'));

            /*
             * Whenever a text area inside a table of responses gets focus or loses focus
             * we need to recalculate sizes of all text areas inside that particular table.
             *
             * This should fire even when the dropdown is clicked upon.
             */
            $('textarea.expandable').focus(function () {
              updateTextAreaHeights(this);
            });

            $('textarea.expandable').blur(function () {
              updateTextAreaHeights(this);
            });

            $('.table-of-responses-select').click(function () {
              updateTextAreaHeights(this);
            });
          });

          $scope.calcRatingUpperCols = function () {
            if (!angular.isDefined($scope.question.scale.values)) {
              return;
            }

            const total_cols = $scope.question.scale.values.length;
            let upper_cols = Math.floor(total_cols / 3.0);

            if (upper_cols < 1) {
              upper_cols = 1;
            }

            return upper_cols;
          };

          $scope.calcRatingUpperSpaceCols = function () {
            if (!angular.isDefined($scope.question.scale.values)) {
              return;
            }

            const upper_cols = $scope.calcRatingUpperCols();
            return $scope.question.scale.values.length - upper_cols * 2;
          };

          $scope.checkbox_other_click = function (questionId) {
            const chkId = stringHelper.isNullOrEmpty($scope.idPrefix)
              ? '#chk_' + questionId + '_other'
              : '#' + $scope.idPrefix + 'chk_' + questionId + '_other';

            const txtId = stringHelper.isNullOrEmpty($scope.idPrefix)
              ? '#text-checkbox-other-' + questionId
              : '#' + $scope.idPrefix + 'text-checkbox-other-' + questionId;

            $scope.response.payer_rationale = '';
            const checkedStatus = $(chkId).is(':checked');

            if (checkedStatus) {
              $scope.response.payer_option_selected = true;
              $(txtId).focus();
            } else {
              $scope.response.payer_option_selected = false;
            }
          };

          $scope.toggle_other_option = function (questionId) {
            const elemId = stringHelper.isNullOrEmpty($scope.idPrefix)
              ? '#chk_' + questionId + '_other'
              : '#' + $scope.idPrefix + 'chk_' + questionId + '_other';

            $scope.response.payer_option_selected = $(elemId).is(':checked');

            if (!$scope.response.payer_option_selected) {
              $scope.response.payer_option = '';
            }
          };

          $scope.radio_other_click = function (questionId) {
            $scope.response.payer_option_selected = true;

            const txtId = stringHelper.isNullOrEmpty($scope.idPrefix)
              ? '#text-radio-other-' + questionId
              : '#' + $scope.idPrefix + 'text-radio-other-' + questionId;

            $(txtId).focus();
            $scope.response.response_value = '';
          };

          $scope.other_textbox_click = function (questionId) {
            const elemId = stringHelper.isNullOrEmpty($scope.idPrefix)
              ? '#chk_' + questionId + '_other'
              : '#' + $scope.idPrefix + 'chk_' + questionId + '_other';

            $(elemId).prop('checked', true);
            $scope.response.payer_option_selected = true;
          };

          $scope.rating_other_change = function () {
            // reset other payer value if there is no other text
            if (!$scope.response.payer_option) {
              $scope.response.payer_value = '';
            }
          };

          $scope.radio_normal_click = function () {
            // this is obsolete, probably can be removed
            // reset other selections
            $scope.response.payer_option = '';
            $scope.response.payer_option_selected = false;
          };

          $scope.input_other_click_or_change = function (questionId) {
            // reset other selections
            if ($scope.response.payer_option) {
              $scope.response.response_value = '';
            }

            const id = '#' + $scope.idPrefix + 'radio_' + questionId + '_other';
            $(id).prop('checked', true);
            $scope.response.payer_option_selected = true;
          };

          $scope.ranking_scale_clicked = function (question, option_id, value_id) {
            if (!$scope.response) {
              return;
            }

            for (const cur_option_id in $scope.response.ranking_responses) {
              const scale_value = $scope.response.ranking_responses[cur_option_id].value;
              if (scale_value == value_id && cur_option_id != option_id) {
                delete $scope.response.ranking_responses[cur_option_id];
              }
            }

            //check other option
            if ($scope.question.allow_payer_option &&
              $scope.response.payer_value == value_id && $scope.response.payer_option != option_id) {
              $scope.response.payer_value = '';
            }
          };

          $scope.answerGaborGrangerSubquestion = function (answer_level_id) {
            $scope.response.is_disabled = true;

            const answerLevel = _.findWhere($scope.question.pricing_model.answer_levels,
              { id: answer_level_id });
            let answerLevelName = '';
            if (answerLevel != undefined) {
              answerLevelName = answerLevel.name;
            }

            $scope.response.gabor_granger_responses.push(
              {
                'price': $scope.question.subquestion.price,
                'answer_level_id': answer_level_id,
                'answer_level_name': answerLevelName
              }
            );

            // Set question in focus
            if (!$scope.$parent.is_multipage_survey()) {
              $scope.$parent.set_question_in_focus($scope.question.id);
            }

            $scope.getNextGaborGrangerSubquestion().then(function () {
              // success
              $scope.response.is_disabled = false;
            }, function () {
              // error
              $scope.response.is_disabled = false;
            });
          };

          $scope.prevent_dblclick = function () {
            return false;
          };

          $scope.ready_to_render_tor = function () {
            const isRandomizedOptionsLoaded = $scope.randomizedOptions && $scope.randomizedOptions.cells &&
            $scope.randomizedOptions.cells.length;

            return isRandomizedOptionsLoaded;
          };

          $scope.getNextGaborGrangerSubquestion = function () {
            if (!$scope.response.gabor_granger_responses) {
              $scope.response.gabor_granger_responses = [];
            }

            let url = '';
            if (authHelper.isUserPayer()) {
              url = apiHelper.getApiUrl() + '/api/payer/survey/question/next/' + $scope.question.id + '.json';
            } else {
              url = apiHelper.getApiUrl() + '/api/authoring/survey/question/next/' + $scope.question.id + '.json';
            }
            const data = { 'gabor_granger_responses': $scope.response.gabor_granger_responses };

            const questionSelector = 'question-' + $scope.question.id + ' .preview-question';

            // Animation -- hide the question text
            $(questionSelector).slideUp(100);
            return HttpAuth.put(url, data).then(function (result) {
              // check if this is last subquestion
              if (!result.data.price) {
                if (!$scope.question.subquestion) {
                  $scope.question.subquestion = {};
                }

                $scope.question.subquestion.is_last = true;

                // Reset question in focus
                if (!$scope.$parent.is_multipage_survey()) {
                  $scope.$parent.set_question_in_focus(null);
                }
              } else {
                // Show the question text
                $(questionSelector).slideDown(300);
                $scope.question.subquestion = result.data;
                $scope.question.subquestion.is_last = false;
              }
            }, function (result) {
              portalHelper.showErrorCommon(result);
            });
          };

          if ($scope.question.type == CONSTANTS.questionTypeIds.GABOR_GRANGER_PRICING_MODEL) {
            const is_view_survey = ($location.path().indexOf('/Payers/ViewSurvey') === 0);
            const is_pilot_survey = ($location.path()
              .indexOf('/Client/TestSurvey') === 0) || ($location.path()
              .indexOf('/Admin/TestSurvey') === 0);
            const is_payer_clarification_request = ($location.path().indexOf('/Payers/ViewRequest') === 0);

            if (authHelper.isUserPayer() && (is_view_survey || is_payer_clarification_request)) {
              if ($scope.response.clarification_request &&
                  $scope.response.clarification_request.is_response_reset) {
                $scope.response.gabor_granger_responses = [];
              }
              $scope.getNextGaborGrangerSubquestion();
            } else if (!authHelper.isUserPayer() && is_pilot_survey) {
              $scope.getNextGaborGrangerSubquestion();
            }
          }

          $scope.parseValue = function(scale_value) {
            return scale_value && scale_value.value ? parseFloat(scale_value.value) || 0 : 0;
          };

        }
      };
    }]
);
